export default "__VITE_ASSET__AgQWHfJV__"